import React, {Component} from "react"
import {CancelButton, SubmitButton} from "../Common/Buttons";
import {ManuallyRegisterDebatersDialog} from "../EventManagementComps/ManuallyRegisterDebatersDialog";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import {debatePositions, debateRanks} from "../Common/debateInfo";

/**
 * Main component for creating, editing and deleting events
 * Can be used for creating new events on an available date, or editing/deleting events of a given date
 * Manages both the events' unified schedule (date, registration, check-in)
 * and specific attributes per event (location, time, etc.)
 */
export class NewDebateResultForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openChairDialog: false,
            openPartnerDialog: false,
            info_slide: "",
            speaker_points: 0,
            motion: "",
            position: debatePositions.og,
            rank: debateRanks.none,
            time: new Date(),
            partner: {},
            chair: {}
        };
    }

    render() {
        return (
            <div style={{paddingTop: 20, paddingBottom: 20}}>
                {this.getTimePicker()}
                <br/>
                <br/>
                <br/>
                {this.getInfoSlideField()}
                <br/>
                {this.getMotionField()}
                <br/>
                <br/>
                <br/>
                {this.getPositionSelector()}
                <br/>
                <br/>
                {this.getRankSelector()}
                <br/>
                <br/>
                {this.getSpeakerPointsField()}
                <br/>
                <br/>
                <br/>
                {this.getPartnerForm()}

                <br/>
                <br/>
                {this.getChairForm()}

                <br/>
                <br/>
                <div align="center" style={{marginTop: '10px'}}>
                    <CancelButton
                        onClick={() => this.props.onClose()}
                        label={"Close"}/>

                    <SubmitButton
                        // disabled={!eventsWereChanged && !eventsWereDeleted}
                        onClick={() => {
                            let missingStuff = [];
                            if (Object.keys(this.state.chair).length === 0) {
                                missingStuff.push("chair");
                            }
                            if (this.state.motion === "") {
                                missingStuff.push("motion");
                            }
                            if (missingStuff.length > 0) {
                                alert("Missing " + missingStuff.join(", "));
                            } else {
                                this.props.onSubmit(this.state);
                            }
                        }}
                        label={"Submit"}/>
                </div>
            </div>
        );
    }

    getPartnerForm() {
        return <>
            <label style={{fontSize: 16}}>Partner: </label>
            {this.state.partner.full_name_eng || "Not Selected"}<span>&nbsp;&nbsp;&nbsp;</span>
            <Button onClick={() => this.setState({openPartnerDialog: true})}
                    variant="contained"
                    color="primary">
                Select Partner
            </Button>
            {this.state.openPartnerDialog &&
            <ManuallyRegisterDebatersDialog
                registeredDebaterIds={{}}
                onClose={(debaters) =>
                    this.setState({partner: (debaters || [])[0] || this.state.partner, openPartnerDialog: false})
                }
                onAddFakeDebaters={debaters => {
                }}
            />
            }
        </>;
    }

    getChairForm() {
        return <>
            <label style={{fontSize: 16}}>Chair: </label>
            {this.state.chair.full_name_eng || "Not Selected"}<span>&nbsp;&nbsp;&nbsp;</span>
            <Button onClick={() => this.setState({openChairDialog: true})}
                    variant="contained"
                    color="primary">
                Select Chair
            </Button>
            {this.state.openChairDialog &&
            <ManuallyRegisterDebatersDialog
                registeredDebaterIds={{}}
                onClose={(debaters) =>
                    this.setState({chair: (debaters || [])[0] || this.state.chair, openChairDialog: false})
                }
                onAddFakeDebaters={debaters => {
                }}
            />
            }
        </>;
    }

    getRankSelector() {
        return <>
            <label style={{fontSize: 16}}>Rank: </label>
            <Select
                label={"Rank"}
                style={{marginLeft: 10, padding: 0, marginBottom: 0}}
                onChange={e => this.setState({rank: e.target.value})}
                value={this.state.rank}>
                {Object.entries(debateRanks).map(rank => {
                    return (
                        <MenuItem
                            key={rank[0]}
                            value={rank[1]}
                            style={{
                                display: "flex",
                                border: "1px solid #ccc",
                                borderRadius: "0px",
                                backgroundColor: "#FFFFFF"
                            }}>
                            <ListItemText
                                style={{display: "inline", marginLeft: 10}}
                                primary={<span>{rank[1].selectionTitle}</span>}/>
                            <br/>
                        </MenuItem>
                    );
                })}
            </Select>
        </>;
    }

    getPositionSelector() {
        return <>
            <label style={{fontSize: 16}}>Position: </label>
            <Select
                label={"Position"}
                style={{marginLeft: 10, padding: 0, marginBottom: 0}}
                onChange={e => this.setState({position: e.target.value})}
                value={this.state.position}>
                {Object.entries(debatePositions).map(position => {
                    return (
                        <MenuItem
                            key={position[0]}
                            value={position[1]}
                            style={{
                                display: "flex",
                                border: "1px solid #ccc",
                                borderRadius: "0px",
                                backgroundColor: "#FFFFFF"
                            }}>
                            <ListItemText
                                style={{display: "inline", marginLeft: 10}}
                                primary={<span>{position[1].title}</span>}/>
                            <br/>
                        </MenuItem>
                    );
                })}
            </Select>
        </>;
    }

    getMotionField() {
        return <TextField label="Motion"
                          inputProps={{style: {textAlign: 'center'}}}
                          style={{
                              maxWidth: "90%",
                              width: 500,
                              marginBottom: 10,
                              marginLeft: 5,
                              marginRight: 5
                          }}
                          onChange={(e) => this.setState({motion: e.target.value})}
        />;
    }

    getInfoSlideField() {
        return <TextField label="Info Slide"
                          inputProps={{style: {textAlign: 'center'}}}
                          style={{
                              maxWidth: "90%",
                              width: 500,
                              marginBottom: 10,
                              marginLeft: 5,
                              marginRight: 5
                          }}
                          onChange={(e) => this.setState({info_slide: e.target.value})}
        />;
    }

    getSpeakerPointsField() {
        return <div>
            <label style={{fontSize: 16}}>Speaker Points: </label>
            <TextField
                       inputProps={{style: {textAlign: 'center'}}}
                       value={this.state.speaker_points}
                       type="number"
                       style={{
                           width: 50,
                           marginLeft: 5,
                           marginRight: 5
                       }}
                       onChange={(e) => this.setState({speaker_points: e.target.value})}
            />
        </div>;
    }

    getTimePicker() {
        return <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DateTimePicker
                showTodayButton={true}
                style={{width: 135, margin: 8}}
                label="Time"
                value={this.state.time}
                ampm={false}
                maxDate={new Date()}
                onChange={(dt) => this.setState({time: dt})}/>
        </MuiPickersUtilsProvider>;
    }
}
